import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import ReactHtmlParser from "react-html-parser";
import { convertFromRaw } from "draft-js";
import { Button } from "@revvsales/components";

import { readDataFromLocalStorage } from "../../utils/globalUtils";
import NoteEditor from "./NotesEditor";
import NotesAttachment from "./NotesAttachment";

import getEditorHTML from "../RevvEditor/getEditorHtml";

class NoteItem extends Component {
  // on clicking header, the section component should be scrolled to view
  _onNotesClick = sectionID => {
    const component = document.getElementById(sectionID);
    if (component !== null) {
      component.scrollIntoView({ behavior: "smooth" });
    } else {
      console.debug(sectionID);
      console.debug("component not found");
    }
  };

  _documentNotes = () => {
    const {
      content,
      anchor: { action, id },
    } = this.props.note;
    const type =
      action && typeof action === "string" ? action.toLowerCase() : "";

    if (!type || !content[type]) {
      return null;
    }
    return (
      <div
        className={`note-${type}`}
        onClick={() => this._onNotesClick(id)}
        onKeyDown={() => this._onNotesClick(id)}
        role="button"
        tabIndex={0}>
        {content[type]}
      </div>
    );
  };

  _editNote = () => {
    const { note, openNoteEditor } = this.props;
    openNoteEditor(note.id);
  };

  _deleteNote = () => {
    const { note, deleteNote } = this.props;
    deleteNote(note);
  };

  _actionButtons = () => {
    const { note, activeNoteID, noteThread } = this.props;
    const { id, author_id: authorID } = note;
    const { comment_status: commentStatus, anchor } = noteThread;
    if (id === undefined || id === null) {
      return null;
    }
    if (
      anchor &&
      anchor.action &&
      (anchor.action === "DELETED" ||
        anchor.action === "INSERTED" ||
        anchor.action === "COMMENTS")
    ) {
      return null;
    }
    const currentUser = readDataFromLocalStorage("revvsalesUser");
    if (
      currentUser &&
      currentUser.id === authorID &&
      activeNoteID !== note.id &&
      commentStatus !== "RESOLVED"
    ) {
      return (
        <div className="note-header-menu">
          <Button
            className="btn-icon noteitem-action-btn-icon"
            data-test="noteitem-menu-btn">
            <span>
              <FontAwesomeIcon icon={["far", "ellipsis-v"]} />
            </span>
          </Button>
          <div
            data-test="noteitem-note-action-items"
            className="note-action-items">
            <Button
              data-test="noteitem-edit-button"
              className="noteitem-action-btn"
              onClick={this._editNote}>
              <FontAwesomeIcon
                icon={["far", "edit"]}
                className="noteitem-action-icon"
              />
              Edit
            </Button>
            <Button
              data-test="noteitem-delete-button"
              className="noteitem-action-btn"
              onClick={this._deleteNote}>
              <FontAwesomeIcon
                icon={["far", "trash-alt"]}
                className="noteitem-action-icon"
              />
              Delete
            </Button>
          </div>
        </div>
      );
    }
    return null;
  };

  _getNoteView = () => {
    const { activeNoteID, note } = this.props;
    if (note.id === null || activeNoteID === note.id) {
      return (
        <NoteEditor
          note={note}
          {...this.props}
          content={note.content}
          noteType={this.props.noteType}
          toggleNoteType={this.props.toggleNoteType}
        />
      );
    }
    let noteMessage = null;
    if (Object.prototype.hasOwnProperty.call(note.content, "draftJSNote")) {
      noteMessage = ReactHtmlParser(
        getEditorHTML(
          convertFromRaw(note.content.draftJSNote[0]),
          "DRAFTJSNOTE",
        ),
      );
    } else if (typeof note.content.message === "string") {
      if (note.content.comments) {
        noteMessage = ReactHtmlParser(note.content.message);
      } else {
        noteMessage = note.content.message;
      }
    } else if (typeof note.content.message === "object") {
      noteMessage = note.content.message.message;
    }
    return (
      <span data-test="noteitem-note-body" className="note-body">
        {noteMessage}
        <NotesAttachment attachments={note.attachments} />
      </span>
    );
  };

  render() {
    const {
      id,
      author: { name, image_url: noteAutherProfileImageUrl } = {},
      created_at: createdAt,
      is_edited: isEdited,
      is_public: isPublicNote,
    } = this.props.note;
    const { is_public: isBasePublic } = this.props.noteThread;
    return (
      <div
        data-test="noteitem-note-wrapper"
        className={`note-wrapper ${
          !isBasePublic && !isPublicNote ? "private-note" : ""
        }`}
        id={`note-wrapper-${id}`}>
        {id !== null ? (
          <div className="note-header">
            <div className="note-author">
              <div>
                <img
                  src={noteAutherProfileImageUrl}
                  data-test="noteitem-avator"
                  className="note-avator"
                  alt="Revv"
                />
              </div>
              <div data-test="noteitem-author-name" className="author-name">
                {id !== null ? name : null}
                <span data-test="noteitem-note-time" className="note-time">
                  {id !== undefined && id !== null
                    ? moment(createdAt).calendar()
                    : null}
                  {isEdited ? " (EDITED)" : ""}
                </span>
              </div>
              {!this.props.isSharedDocument && this._actionButtons()}
            </div>
          </div>
        ) : null}

        <div
          data-test="noteitem-note-body-wrapper"
          className="note-body-wrapper">
          {this._documentNotes()}
          {this._getNoteView()}
        </div>
      </div>
    );
  }
}

export default NoteItem;



// WEBPACK FOOTER //
// ./src/components/Notes/NoteItem.js